import { useState } from "react";

const useDidMountWithoutLifeCycle = (fn: () => void) => {
  const [mounted, setMounted] = useState(false);
  if (mounted) return;
  setMounted(true);
  fn();
};

export default useDidMountWithoutLifeCycle;
